import $ from 'jquery';

export default function(protoProps, staticProps) {
  var parent = this,
    child;

  // Figure out our constructor
  if(protoProps && protoProps.hasOwnProperty('constructor')) {
    child = protoProps.constructor;
  } else {
    child = function() { return parent.apply(this, arguments); };
  }

  // Add any statics
  $.extend(child, parent, staticProps);

  // Setup the proto chain
  child.prototype = $.extend({}, parent.prototype, protoProps);
  child.prototype.constructor = child;

  // Store a reference in case
  child.__super__ = parent.prototype;

  return child;
};
